import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthContext';

function AddPoints() {
  const [finalists, setFinalists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  
  // فرم states
  const [selectedUserId, setSelectedUserId] = useState("");
  const [points, setPoints] = useState("");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);

   const { apiBaseUrl } = useAuth();
  
  // اینجا رو تنظیم کن
  const headers = {
    // هدرهای مورد نیاز (مثل Authorization) رو اینجا اضافه کن
    'Content-Type': 'application/json'
  };

  useEffect(() => {
    fetchFinalists();
  }, []);

  async function fetchFinalists() {
    try {
      setLoading(true);
      setError("");
      const res = await fetch(`${apiBaseUrl}/api/final/finalists`, {
        headers,
      });
      if (!res.ok) throw new Error("خطا در دریافت فینالیست‌ها");
      const json = await res.json();
      console.log("Finalists Response:", json);
      setFinalists(json?.items || []);
    } catch (e) {
      setError(e.message || "خطای نامشخص");
      console.error("Error fetching finalists:", e);
    } finally {
      setLoading(false);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (!selectedUserId || !points || !description) {
      alert("لطفا تمام فیلدها را پر کنید");
      return;
    }

    try {
      setSubmitting(true);
      const res = await fetch(`${apiBaseUrl}/api/transfer-market/manual/${selectedUserId}`, {
        method: 'POST',
        headers: {
          ...headers,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          points: parseInt(points),
          description: description
        })
      });
      
      if (!res.ok) throw new Error("خطا در اضافه کردن امتیاز");
      
      const result = await res.json();
      console.log("Add Points Result:", result);
      alert("امتیاز با موفقیت اضافه شد!");
      
      // ریست کردن فرم
      setSelectedUserId("");
      setPoints("");
      setDescription("");
      
      // رفرش لیست
      fetchFinalists();
    } catch (e) {
      console.error("Error adding points:", e);
      alert(e.message || "خطا در اضافه کردن امتیاز");
    } finally {
      setSubmitting(false);
    }
  }

  if (loading) return <div style={styles.loading}>در حال بارگذاری...</div>;
  if (error) return <div style={styles.error}>خطا: {error}</div>;

  // پیدا کردن کاربر انتخاب شده برای نمایش اطلاعات
  const selectedUser = finalists.find(f => f.user_id === parseInt(selectedUserId));

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>افزودن امتیاز دستی</h2>
      
      {/* فرم اصلی */}
      <div style={styles.formContainer}>
        <form onSubmit={handleSubmit} style={styles.form}>
          
          {/* انتخاب کاربر */}
          <div style={styles.formGroup}>
            <label style={styles.label}>انتخاب فینالیست:</label>
            <select 
              value={selectedUserId}
              onChange={(e) => setSelectedUserId(e.target.value)}
              style={styles.select}
              required
            >
              <option value="">-- یک فینالیست را انتخاب کنید --</option>
              {finalists.map((finalist) => (
                <option key={finalist.user_id} value={finalist.user_id}>
                  {finalist.first_name} {finalist.last_name} - رتبه: {finalist.rank} - امتیاز فعلی: {finalist.points}
                </option>
              ))}
            </select>
          </div>

          {/* نمایش اطلاعات کاربر انتخاب شده */}
          {selectedUser && (
            <div style={styles.userInfo}>
              <h4>اطلاعات کاربر انتخاب شده:</h4>
              <p><strong>نام:</strong> {selectedUser.first_name} {selectedUser.last_name}</p>
              <p><strong>ایمیل:</strong> {selectedUser.email}</p>
              <p><strong>رتبه فعلی:</strong> {selectedUser.rank}</p>
              <p><strong>امتیاز فعلی:</strong> {selectedUser.points}</p>
              <p><strong>موجودی:</strong> {selectedUser.balance}</p>
            </div>
          )}

          {/* وارد کردن امتیاز */}
          <div style={styles.formGroup}>
            <label style={styles.label}>امتیاز:</label>
            <input
              type="number"
              value={points}
              onChange={(e) => setPoints(e.target.value)}
              style={styles.input}
              placeholder="مثال: 100"
              required
            />
          </div>

          {/* وارد کردن توضیحات */}
          <div style={styles.formGroup}>
            <label style={styles.label}>توضیحات:</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={styles.textarea}
              placeholder="دلیل اضافه کردن امتیاز را وارد کنید..."
              rows="4"
              required
            />
          </div>

          {/* دکمه ارسال */}
          <button 
            type="submit" 
            disabled={submitting}
            style={{
              ...styles.button,
              opacity: submitting ? 0.6 : 1,
              cursor: submitting ? 'not-allowed' : 'pointer'
            }}
          >
            {submitting ? 'در حال ارسال...' : 'افزودن امتیاز'}
          </button>
        </form>
      </div>

      {/* نمایش لاگ فینالیست‌ها */}
      <div style={styles.logContainer}>
        <h3>لاگ کامل فینالیست‌ها:</h3>
        <pre style={styles.pre}>
          {JSON.stringify(finalists, null, 2)}
        </pre>
      </div>
    </div>
  );
}

// استایل‌ها
const styles = {
  container: {
    padding: '30px',
    maxWidth: '900px',
    margin: '0 auto',
    fontFamily: 'Tahoma, Arial, sans-serif',
    direction: 'rtl'
  },
  title: {
    textAlign: 'center',
    color: '#333',
    marginBottom: '30px'
  },
  formContainer: {
    background: '#fff',
    padding: '30px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    marginBottom: '30px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  label: {
    fontWeight: 'bold',
    color: '#555',
    fontSize: '14px'
  },
  select: {
    padding: '12px',
    fontSize: '14px',
    border: '2px solid #ddd',
    borderRadius: '6px',
    outline: 'none',
    transition: 'border-color 0.3s',
    cursor: 'pointer'
  },
  input: {
    padding: '12px',
    fontSize: '14px',
    border: '2px solid #ddd',
    borderRadius: '6px',
    outline: 'none',
    transition: 'border-color 0.3s'
  },
  textarea: {
    padding: '12px',
    fontSize: '14px',
    border: '2px solid #ddd',
    borderRadius: '6px',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'Tahoma, Arial, sans-serif',
    transition: 'border-color 0.3s'
  },
  userInfo: {
    background: '#f0f8ff',
    padding: '15px',
    borderRadius: '6px',
    border: '1px solid #b3d9ff'
  },
  button: {
    padding: '14px',
    fontSize: '16px',
    fontWeight: 'bold',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'transform 0.2s',
  },
  logContainer: {
    background: '#f8f9fa',
    padding: '20px',
    borderRadius: '10px',
    border: '1px solid #dee2e6'
  },
  pre: {
    background: '#fff',
    padding: '15px',
    borderRadius: '6px',
    overflow: 'auto',
    maxHeight: '400px',
    fontSize: '12px',
    border: '1px solid #e0e0e0'
  },
  loading: {
    textAlign: 'center',
    padding: '50px',
    fontSize: '18px',
    color: '#666'
  },
  error: {
    textAlign: 'center',
    padding: '50px',
    fontSize: '18px',
    color: '#dc3545'
  }
};

export default AddPoints;